// Expiry checks are for the UI only. The server still verifies every JWT.
export function readSavedSession(storage = localStorage, now = Date.now()) {
  try {
    const saved = storage.getItem('userInfo');
    if (!saved) return null;
    const user = JSON.parse(saved);
    if (!user || typeof user.token !== 'string') throw new Error('Invalid session');
    const parts = user.token.split('.');
    if (parts.length !== 3) throw new Error('Invalid token');
    const encoded = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(atob(encoded.padEnd(Math.ceil(encoded.length / 4) * 4, '=')));
    if (!Number.isFinite(payload.exp) || payload.exp * 1000 <= now) throw new Error('Expired session');
    return user;
  } catch {
    storage.removeItem('userInfo');
    return null;
  }
}

export function clearMatchingSession(token, storage = localStorage) {
  try {
    const current = JSON.parse(storage.getItem('userInfo') || 'null');
    if (!current || current.token !== token) return false;
    storage.removeItem('userInfo');
    return true;
  } catch { return false; }
}
